<template>
    <div class="af-profile-menu afu-flex afu-flex-wrap afu-justify-center md:afu-justify-start afu-p-0 afu-m-0 afu-mb-10">
        <div
            v-for="nav in menu"
            :key="nav.label"
            class="af-profile-menu-item afu-mx-3 first:afu-ml-0 last:afu-mr-0"
            :class="[{ 'is-active': nav.is_active }, `af-dash-nav-${nav.label}`]"
        >
            <a
                href=""
                @click.stop.prevent="changeMenu(nav)"
                class="afu-flex afu-py-3 afu-border-b afu-border-t-0 afu-border-r-0 afu-border-l-0 afu-border-solid afu-whitespace-no-wrap afu-no-underline hover:afu-no-underline afu-font-semibold"
                :class="{
                    'afu-text-neutral-dark hover:afu-text-primary afu-border-transparent': !nav.is_active,
                    'afu-text-primary hover:afu-text-black afu-border-primary': nav.is_active
                }"
            >
                {{ nav.label }}
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Submenu',

        props: {
            menu: {
                type: Array,
                default: () => [],
            },
        },

        methods: {
            changeMenu(nav) {
                this.$emit('menuChange', nav);
            },
        },
    };
</script>
